export const AUTOPAY = {
    FEEDBACK_SHOWN: "autopay_feedback_shown",
    FEEDBACK_URL: "https://webviews.swiggy.com/feedback/autopay_feedback.html?context=autopayFeedback&order_id={0}",
    FEEDBACK_DEEPLINK: "swiggy://externalWidget?banner_type=WEBVIEW&card_type=HALF_CARD&url={0}",
};
